import React from 'react';
import '../../App.css';



function Footer() {




  return (
    <div className='container-xl'>
      <div className="row my-sections">
        <div className="col-lg repo-div">
          <h4>More</h4>
          <p>
            <a href="https://gormthewyrm.github.io/react-portfolio/" target="_blank" rel="noopener noreferrer">Link
                            to my Portfolio page</a></p>
        <p>Copyright 2020</p>
</div>
      </div >
    </div>
  )
};
export default Footer;